export default __webpack_public_path__ + "static/media/photo--sm--group-wide.d7c21dc9.jpg";